<template>
  <div class="plazza-post-page">
    <!-- 头部 -->
    <div class="post-header">
      <div class="header-back" @click="goBack">
        <span class="back-icon">‹</span>
      </div>
      <div class="header-title">发帖</div>
    </div>

    <!-- 内容区域 -->
    <div class="post-content">
      <!-- 文本输入 -->
      <div class="text-area-wrap">
        <div class="text-toolbar">
          <span class="toolbar-icon">A</span>
          <span class="toolbar-icon">😊</span>
        </div>
        <textarea
          v-model="form.content"
          placeholder="这一刻的想法..."
          maxlength="200"
          class="post-textarea"
        ></textarea>
        <div class="text-count">{{ form.content.length }} / 200</div>
      </div>

      <!-- 图片上传 -->
      <div class="image-upload">
        <div class="uploaded-images" v-if="uploadedImages.length > 0">
          <div class="image-item" v-for="(img, i) in uploadedImages" :key="i">
            <img :src="$imgUrl(img.url || img.path)" class="uploaded-img" />
            <div class="image-delete" @click="removeImage(i)">×</div>
          </div>
          <div class="upload-btn" v-if="uploadedImages.length < 3" @click="$refs.fileInput.click()">
            <span class="upload-plus">+</span>
          </div>
        </div>
        <div class="upload-btn" v-else @click="$refs.fileInput.click()">
          <span class="upload-plus">+</span>
        </div>
        <input
          ref="fileInput"
          type="file"
          accept="image/*"
          multiple
          style="display:none"
          @change="handleFileUpload"
        />
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="post-footer">
      <div class="btn-cancel" @click="goBack">取消</div>
      <div class="btn-publish" :class="{ disabled: submitting }" @click="submitPost">
        {{ submitting ? '发布中...' : '发布' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlazzaPost',
  data() {
    return {
      form: {
        content: '',
      },
      uploadedImages: [],
      submitting: false,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    handleFileUpload(e) {
      const files = Array.from(e.target.files || []);
      if (!files.length) return;
      const remain = 3 - this.uploadedImages.length;
      const toUpload = files.slice(0, remain);
      if (toUpload.length < files.length) {
        this.$toast('最多上传3张图片');
      }
      toUpload.forEach(file => {
        if (file.size > 10 * 1024 * 1024) {
          this.$toast('图片大小不能超过10MB');
          return;
        }
        const formdata = new FormData();
        formdata.append('file', file);
        this.$apiFun.post('/api/uploadimg', formdata).then(res => {
          if (res && res.code === 200 && res.data) {
            // 预览用url(带域名)，存储用path(不带域名)
            var imgUrl = res.data;
            var imgPath = res.data.replace(/^https?:\/\/[^/]+/i, '');
            this.uploadedImages.push({ url: imgUrl, path: imgPath });
          } else {
            this.$toast((res && res.message) || '上传失败');
          }
        }).catch(() => {
          this.$toast('上传失败');
        });
      });
      e.target.value = '';
    },
    removeImage(i) {
      this.uploadedImages.splice(i, 1);
    },
    submitPost() {
      if (this.submitting) return;
      if (!this.form.content.trim()) {
        this.$toast('请输入帖子内容');
        return;
      }
      this.submitting = true;
      var submitImages = this.uploadedImages.map(function (img) {
        return img.path;
      });
      this.$apiFun.post('/api/plazza/post/create', {
        content: this.form.content,
        images: submitImages,
      }).then(res => {
        if (res.code === 200) {
          this.$toast('发帖成功，等待审核');
          window.__plazzaNeedRefresh = true;
          this.$router.back();
        } else {
          this.$toast(res.msg || '发帖失败');
          this.submitting = false;
        }
      }).catch(e => {
        console.error('发帖失败', e);
        this.$toast('发帖失败');
        this.submitting = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.plazza-post-page {
  min-height: 100vh;
  background: #0a0a0a;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.post-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 1.1rem;
  background: #1a1a1a;

  .header-back {
    position: absolute;
    left: 0.3rem;
    display: flex;
    align-items: center;
    cursor: pointer;

    .back-icon {
      font-size: 0.6rem;
      color: #fff;
    }
  }

  .header-title {
    font-size: 0.4rem;
    color: #fff;
  }
}

.post-content {
  flex: 1;
  padding: 0.3rem;
}

.text-area-wrap {
  background: #1a1a1a;
  border-radius: 0.2rem;
  padding: 0.3rem;
  position: relative;
}

.text-toolbar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.2rem;

  .toolbar-icon {
    font-size: 0.4rem;
    color: #999;
    cursor: pointer;
  }
}

.post-textarea {
  width: 100%;
  min-height: 3rem;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 0.32rem;
  line-height: 1.5;
  resize: none;

  &::placeholder {
    color: #666;
  }
}

.text-count {
  position: absolute;
  bottom: 0.3rem;
  right: 0.3rem;
  font-size: 0.24rem;
  color: #666;
}

.image-upload {
  margin-top: 0.3rem;
}

.uploaded-images {
  display: flex;
  flex-wrap: wrap;
  gap: 0.2rem;
}

.image-item {
  width: 2rem;
  height: 2rem;
  position: relative;
  border-radius: 0.1rem;
  overflow: hidden;

  .uploaded-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .image-delete {
    position: absolute;
    top: 0.1rem;
    right: 0.1rem;
    width: 0.4rem;
    height: 0.4rem;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.3rem;
    color: #fff;
    cursor: pointer;
    line-height: 1;
  }
}

.upload-btn {
  width: 2rem;
  height: 2rem;
  background: #1a1a1a;
  border: 1px dashed #444;
  border-radius: 0.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .upload-plus {
    font-size: 0.8rem;
    color: #666;
  }
}

.post-footer {
  display: flex;
  gap: 0.3rem;
  padding: 0.3rem;
  padding-bottom: calc(0.3rem + env(safe-area-inset-bottom));
}

.btn-cancel {
  flex: 1;
  height: 0.9rem;
  background: #2a2a2a;
  border-radius: 0.45rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.32rem;
  color: #ccc;
  cursor: pointer;
}

.btn-publish {
  flex: 1;
  height: 0.9rem;
  background: linear-gradient(135deg, #d1ae52 0%, #b8943f 100%);
  border-radius: 0.45rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.32rem;
  color: #000;
  font-weight: 500;
  cursor: pointer;

  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/plazzaPost.vue